import script from "./PackageRetentionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageRetentionDialog.vue?vue&type=script&setup=true&lang=ts"

import "./PackageRetentionDialog.vue?vue&type=style&index=0&id=4ffa92f3&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ffa92f3"]])

export default __exports__